import { notRequiredString, requiredStringMaxCharsValidation } from '../strings';

const hasNumbers = (value: string) => /\d/.test(value);
const hasSpecialChars = (value: string) => /[^a-zA-Z\s\- .&']/.test(value);

const validateNumbers = (value: string | null | undefined) => {
  if (!value) return true;
  return !hasNumbers(value);
};

const validateSpecialChars = (value: string | null | undefined) => {
  if (!value) return true;
  return !hasSpecialChars(value);
};

export const basicNameValidation = requiredStringMaxCharsValidation({})
  .test('name-characters', 'No numbers', validateNumbers)
  .test('name-special-chars', 'No special characters', validateSpecialChars);

export const nameValidationMax30 = requiredStringMaxCharsValidation({ max: 30 })
  .test('name-characters', 'No numbers', validateNumbers)
  .test('name-special-chars', 'No special characters', validateSpecialChars);

export const middleNameValidation = notRequiredString
  .max(30, 'Name must be 30 characters or less')
  .test('name-characters', 'No numbers', validateNumbers)
  .test('name-special-chars', 'No special characters', validateSpecialChars);
